import { isChannelMobileApp } from "@chewy/request-utils/dist/getChannelType";
export const isMobileApp = () => {
  const ua = window.navigator.userAgent;
  return isChannelMobileApp(ua) ?? false;
};
